
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"52","viewBox":"0 0 65 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M7.645 9.233h22.941v23.021H7.645zM34.414 9.233h22.941v23.021H34.414z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"3.693","d":"M7.645 36.685H57.35M7.645 40.871H57.35"}})])
          )
        }
      }
    